import styled from 'styled-components';
import React, { useCallback, forwardRef } from 'react';

const UnstyledButtonComp = styled.button`
  display: inline-block;
  border: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
  background: none;
  color: #000000;
  font-family: sans-serif;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  user-select: none;

  &:focus {
    outline: none;
  }
`;

const UnstyledButton = forwardRef(
  (
    {
      onClick,
      ...restProps
    }: {
      children?: React.ReactNode;
      className?: string;
      onClick?: (e: React.MouseEvent) => void;
    },
    ref?:
      | ((instance: HTMLButtonElement | null) => void)
      | React.MutableRefObject<HTMLButtonElement | null>
      | null,
  ) => {
    const onBtnClick = useCallback(
      (e: React.MouseEvent) => {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      },
      [onClick],
    );

    return (
      <UnstyledButtonComp
        ref={ref}
        onClick={onBtnClick}
        {...restProps}
      />
    );
  },
);

export default UnstyledButton;
